import { queryOptions } from '@tanstack/react-query';
import { WalletSettlementFilesQueryParamsType } from './walletSettlementFilesQuery.type';
import { walletSettlementFilesFunction } from './walletSettlementFilesQueryFunction';

export const walletSettlementFilesQueryOptions = (
  params: WalletSettlementFilesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['wallet-settlement-files', params],
    queryFn: () => walletSettlementFilesFunction(params),
  });
};
